module.exports = __webpack_public_path__ + "static/img/装饰10.9ebadbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰10.svg
// module id = E5gH
// module chunks = 2